import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'

import EmptyStyles from 'ui/helpers/emptyStyles.css'
import { makeComponent } from 'ui/helpers/recipes'

import { CollapsibleContentStyle } from './Collapsible.css'
export const Root = makeComponent(CollapsiblePrimitive.Root, EmptyStyles)
export const Trigger = makeComponent(CollapsiblePrimitive.Trigger, EmptyStyles)
export const Content = makeComponent(CollapsiblePrimitive.Content, CollapsibleContentStyle)
